import { useState, useEffect } from "react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import OfferCard from "../components/OfferCard";
import { Skeleton } from "../components/ui/skeleton";

export default function Offers() {
  const { t } = useApp();
  const [offers, setOffers] = useState(null);

  useEffect(() => {
    api.get("/offers").then((r) => setOffers(r.data)).catch(() => setOffers([]));
  }, []);

  return (
    <div className="pt-28 sm:pt-32">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-foreground">{t.offers.title}</h1>
          <p className="text-muted-foreground mt-3 text-lg">{t.offers.subtitle}</p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 pb-8">
          {offers === null
            ? Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-96 rounded-3xl" />)
            : offers.length === 0
              ? <p className="col-span-full text-center text-muted-foreground py-16">{t.offers.none}</p>
              : offers.map((o, i) => <OfferCard key={o.id} offer={o} index={i} />)}
        </div>
      </div>
    </div>
  );
}
